'use client';

import StarRating from 'components/gruenland/molecules/ratings/StarRating';
import { TYPOGRAPHY_PRODUCT_DETAIL_TITLE } from 'lib/typography';
import useAverageRatings from './hooks/useAverageRatings';

type Props = {
  productKey?: string;
};

const Rating: React.FC<Props> = ({ productKey }) => {
  const { rating } = useAverageRatings(productKey);
  if (!rating) return null;
  return (
    <>
      <p className={TYPOGRAPHY_PRODUCT_DETAIL_TITLE}>{rating}</p>
      <StarRating rating={rating} />
    </>
  );
};

export default Rating;
